module.exports = __webpack_public_path__ + "static/media/Shittu.d77926b8.jpeg";